<div class="page-container">
  <form>
    <app-text-input [control]="getControl('name')" [label]="'courses.course_name' | translate" [placeholder]="'courses.course_name_placeholder' | translate"></app-text-input>
    <app-color-picker [control]="getControl('color')" [label]="'courses.course_color' | translate" [placeholder]="'controls.select_color' | translate"></app-color-picker>
    <div class="buttons-container">
      <app-button [text]="'courses.create_course' | translate" type="button" (click)="saveCourse()" [loading]="isLoading"></app-button>
    </div>
  </form>
</div>